import type { Template } from "@/types";

export const PO_03_H0_V3: Template[] = [
{
    id: "po-03-h0v3-01",
    name: "PO 01 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 115, y: 170, width: 325, height: 510, rotation: 0, imageRotation: 0 },
            { id: "2", x: 448, y: 170, width: 324, height: 510, rotation: 0, imageRotation: 0 },
            { id: "3", x: 780, y: 170, width: 324, height: 510, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-03-h0v3-02",
    name: "PO 02 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 49, y: 136, width: 368, height: 578, rotation: 0, imageRotation: 0 },
        { id: "2", x: 425, y: 136, width: 368, height: 578, rotation: 0, imageRotation: 0 },
        { id: "3", x: 801, y: 136, width: 367, height: 578, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-03",
    name: "PO 03 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 136, width: 401, height: 578, rotation: 0, imageRotation: 0 },
        { id: "2", x: 409, y: 136, width: 400, height: 578, rotation: 0, imageRotation: 0 },
        { id: "3", x: 817, y: 136, width: 400, height: 578, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-04",
    name: "PO 04 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_04.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 33, y: 170, width: 325, height: 510, rotation: 0, imageRotation: 0 },
            { id: "2", x: 365, y: 43, width: 488, height: 765, rotation: 0, imageRotation: 0 },
            { id: "3", x: 860, y: 170, width: 325, height: 510, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-05",
    name: "PO 05 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 34, y: 0, width: 540, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 650, y: 225, width: 255, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 913, y: 225, width: 255, height: 402, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-06",
    name: "PO 06 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 177, y: 225, width: 255, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 649, y: 225, width: 256, height: 402, rotation: 0, imageRotation: 0 },
            { id: "3", x: 913, y: 225, width: 255, height: 402, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-07",
    name: "PO 07 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 177, y: 0, width: 279, height: 422, rotation: 0, imageRotation: 0 },
            { id: "2", x: 177, y: 429, width: 279, height: 422, rotation: 0, imageRotation: 0 },
            { id: "3", x: 683, y: 66, width: 457, height: 719, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-08",
    name: "PO 08 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 261, y: 69, width: 461, height: 714, rotation: 0, imageRotation: 0 },
            { id: "2", x: 729, y: 69, width: 226, height: 353, rotation: 0, imageRotation: 0 },
            { id: "3", x: 729, y: 429, width: 226, height: 353, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-09",
    name: "PO 09 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_09.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 34, y: 224, width: 266, height: 403, rotation: 0, imageRotation: 0 },
            { id: "2", x: 307, y: 224, width: 265, height: 403, rotation: 0, imageRotation: 0 },
            { id: "3", x: 683, y: 66, width: 457, height: 719, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-03-h0v3-10",
    name: "PO 10 - H0V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-03-h0_v3_10.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 608, height: 852, rotation: 0, imageRotation: 0 },
            { id: "2", x: 669, y: 247, width: 237, height: 359, rotation: 0, imageRotation: 0 },
            { id: "3", x: 913, y: 247, width: 236, height: 359, rotation: 0, imageRotation: 0 }
    ],
}
];